module.exports = __webpack_public_path__ + "static/media/logoKolobAgent.99ca184d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Footer/logoKolobAgent.png
// module id = 2599
// module chunks = 0